function instantMatchV1() {
  if (!process.env.NEXT_PUBLIC_INSTANT_MATCH_V1_FL) return false;

  return process.env.NEXT_PUBLIC_INSTANT_MATCH_V1_FL === 'true';
}

export const INSTANT_MATCH_V1_IS_ENABLED = instantMatchV1();
